<template>
    <div>
        <gateway-filter :action="filterAction" ></gateway-filter>
        <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import columns from '../datatable/gateways-columns'
import {StarShopApiUrl} from '@/common/api.service'
import actionsColumn from './actions-column'
import { AuthorizationHeader } from '@/common/jwt.service'
import  gatewayFilter  from './gateway-filter.vue'
import {gatewayStatus} from "@/constants/gatewayStatus";

export default {

    components: {
        'gateway-filter' : gatewayFilter
    },
    data() {
        return {
            query: {
                gateway_status : gatewayStatus.ACTIVE
            }
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "collective_gateway_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: StarShopApiUrl.path('collective/admin'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style>

</style>